import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Finish from "../../../../../../../assets/images/finish.png";
import Clock from "../../../../../../../assets/images/meetupEvent/clock-icon.png";
import Price from "../../../../../../../assets/images/tagPrice.PNG";
// import Fly from '../../../../../../assets/images/Souvenir/unsplash_Z4RYz52ljts.png';
// import SouvenirAuctionBanner from '../../../../../../assets/images/SouvenirJoti.png';
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import { serverInfo } from "../../../../../../../App";
import { useContext } from "react";

const ApprovedOrDecline = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const { id } = useParams();

  let history = useHistory();

  const approved = () => {
    axios.put(`/api/star/approved/auction/${id}`).then((res) => {
      if (res.status === 200) {
        history.push(`/superstar/auction`);
      }
    });
  };
  const decline = () => {
    axios.put(`/api/star/decline/auction/${id}`).then((res) => {
      if (res.status === 200) {
        history.push(`/superstar/auction`);
      }
    });
  };
  // function editProduct(){
  //     history.push(`/superstar-admin/souvenir/edit-auction/${auctionConfirm.id}`)
  // }

  const [auctionConfirm, setConfirmation] = useState([]);

  useEffect(() => {
    axios.get(`/api/star/approvedOrDecline/auction/${id}`).then((res) => {
      if (res.status === 200) {
        setConfirmation(res.data.product);
      }
    });
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-8 mb-3">
          <div className="card card-bg p-2 mb-3">
            <img
              className="img-fluid banner-pro"
              src={imageCdnUrl + auctionConfirm.banner}
              alt=""
            />
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card card-bg p-2">
            <img
              src={imageCdnUrl + auctionConfirm.product_image}
              alt="Pineapple"
              className="img-fluid banner-pro"
            />
          </div>
        </div>
      </div>

      <div className="row  mb-4 ">
        <div className="col-md-12 ">
          <div className="card card-bg shadow">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="div mb-3">
                  <h4 className="text-light ">{auctionConfirm.name}</h4>
                </div>
                {auctionConfirm.name ? (
                  <div className="div text-warning mb-3">
                    <small>&nbsp;||&nbsp;</small>
                  </div>
                ) : (
                  <></>
                )}
                <div className="div mb-3">
                  <h5 className="text-light ">{auctionConfirm.title}</h5>
                </div>
              </div>

              <h5 className="text-warning">Description</h5>
              <div className="under-line"></div>
              <p className="text-light">
                <Markup content={auctionConfirm.details} />
              </p>
            </div>
          </div>
        </div>

        <div className=" d-flex mt-2 cricket-jersey">
          <div className="d-flex p-2 mb-3  registration-btn card-bg ">
            <div className="mt-2  mx-3 ">
              <span className="text-light">
                {" "}
                <img src={Finish} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1">
              <span className="text-light">Last Date</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                {moment(auctionConfirm.bid_to).format("LL")}
              </span>
            </div>
          </div>

          <div className=" d-flex p-2 mb-3 mx-md-2 registration-btn card-bg ">
            <div className=" mt-2 mx-3">
              <span className="text-light">
                {" "}
                <img src={Clock} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1 ">
              <span className="text-light">Time</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                {moment(auctionConfirm.bid_to).format("LT")}
              </span>
            </div>
          </div>
          <div className=" d-flex p-2 mb-3 mx-md-2 registration-btn card-bg ">
            <div className=" mt-2 mx-3">
              <span className="text-light">
                {" "}
                <img src={Clock} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1 ">
              <span className="text-light">Result Published</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                {moment(auctionConfirm.result_date).format("LL")}
              </span>
            </div>
          </div>
          <div className=" d-flex p-2 mb-3 mx-md-2 registration-btn card-bg ">
            <div className=" mt-2 mx-3">
              <span className="text-light">
                {" "}
                <img src={Clock} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1 ">
              <span className="text-light">Product Delivery</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                {moment(auctionConfirm.product_delivery_date).format("LL")}
              </span>
            </div>
          </div>
          <div className=" d-flex p-2 mb-3  registration-btn card-bg ">
            <div className=" mt-2 mx-3">
              <span className="text-light">
                {" "}
                <img src={Price} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1 ">
              <span className="text-light">Base Price</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                ${auctionConfirm.base_price}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="row justify-content-center mb-4">
        {auctionConfirm?.star_approval < 1 ? (
          <>
            <div className="col-md-2 mb-3">
              <button
                onClick={approved}
                className=" btn btnConfirm w-100 fw-bold mx-1"
              >
                {" "}
                Approved{" "}
              </button>
            </div>
            <div className="col-md-2 mb-3">
              <button
                onClick={decline}
                className=" btn btnDecline w-100 fw-bold mx-1"
              >
                Decline
              </button>
            </div>

            <div className="col-md-2 mb-3">
              <Link to={`/superstar/auction/edit/${id}`}>
                <button className="btn btnUpdate w-100 fw-bold mx-2">
                  Edit
                </button>
              </Link>{" "}
            </div>
          </>
        ) : auctionConfirm.created_by_id === auctionConfirm.star_id &&
          auctionConfirm.status < 1 ? (
          <>
            <div className="col-md-2 mb-3">
              <Link to={`/superstar/auction/edit/${id}`}>
                <button className="btn btnUpdate w-100 fw-bold mx-2">
                  Edit
                </button>
              </Link>{" "}
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default ApprovedOrDecline;
